import axios from "../utils/axios";

export default class service{

    static baseURL = 'auth';

    static login(data){
        return axios.post( this.baseURL + "/login-via-password", data);
    }

     static validateToken(){
        return axios.get( this.baseURL + "/validate-token");
    }
     static updatepassword(data) {
    return axios.post(this.baseURL + "/update-password", data);
  }

   
}